import '../subcatigory/SubcardsSide/subcard.css'
import React, { useState } from "react";
import { useTranslation } from 'react-i18next'
import * as Wish from "../../network/api/wish";
import { useNavigate } from 'react-router-dom';

export const CardWishlist = (props) => {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const product = props.product;

  return (
    <div className="col-12 col-md-6 col-lg-3 card-div-wish border-0 d-flex  flex-column   mt-4" style={{ height: 'fit-content' }}>
      <div className="carousel-wrapper " style={{ height: 'fit-content', width: 'fit-content' }}>
        <img className="d-block arousel-wrapper-imgs card-img" src={`${product?.images[0].secure_url}`} alt='' ></img>
      </div>
      <div className=" card-body-wish d-flex flex-column align-items-start gap-1">
        <div className=" card-body-wish-div1 d-flex flex-column  justify-content-between ">
          <p className=' sub-cat-card-p1 mb-0 brand'>{product?.brand?.name && product?.brand?.name }</p>
          <p className=' sub-cat-card-p2 mb-0 name'>{product?.name}</p>
          <span className=' sub-cat-card-p3-div price'>
            <div className='sub-cat-card-price-before rtl-div price'> {product?.price_after} <span style={{ fontSize: '14px' }}>{t('curency')}</span></div>
          </span>
        </div>
        <div className=" card-body-wish-div2 justify-content-start">
          <button className='wish-addtocart-btn add-cart' onClick={() => navigate(`/productdetails/${product?._id}`)}> {t("Add to cart2")}</button>
          <button className='wish-remove-btn'
            onClick={() => {
              Wish.delete_wish(props.wish?._id).then((e) => {
                props.load();
              })
            }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998" stroke="#ADADAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="#ADADAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M18.8484 9.14014L18.1984 19.2101C18.0884 20.7801 17.9984 22.0001 15.2084 22.0001H8.78844C5.99844 22.0001 5.90844 20.7801 5.79844 19.2101L5.14844 9.14014" stroke="#ADADAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M10.3281 16.5H13.6581" stroke="#ADADAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9.5 12.5H14.5" stroke="#ADADAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}